import { MapDataService } from '@ui/shared/domain-map';
import { map, type Observable, of } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { FoundingMapService, NewFoundingOrderingEnum } from '@ui/shared/util-api';
import { FoundingMapItemModel } from '../../entities/founding-map-item.model';
import type { FoundingMapFilter } from '../../types/founding-map-filters';
import { FoundingDataType } from '../../enums/founding-data-type';
import { FoundingMapItemMapper } from '../../mappers/founding-map-item.mapper';
import { toRequestQuery } from '@ui/shared/util-filter';

@Injectable({ providedIn: 'root' })
export class FoundingNewFoundingMapDataService extends MapDataService<FoundingMapItemModel, FoundingMapFilter> {
    protected _api = inject(FoundingMapService);

    public getData$(filter: FoundingMapFilter): Observable<Array<FoundingMapItemModel>> {
        if (filter.type && filter.type !== FoundingDataType.NewFounding) {
            return of([]);
        }

        if (filter.targetGroup !== null && typeof filter.targetGroup !== 'undefined') {
            return of([]);
        }

        return this._api.getAllNewFoundings({
            nameContains: typeof filter.search === 'string' ? filter.search : null,
            foundingCategoryIds: toRequestQuery(filter.sector),
            order: [NewFoundingOrderingEnum.Name],
        })
            .pipe(map(response => response.data.map(item => FoundingMapItemMapper.fromNewFoundingDto(item))));
    }
}
